import type { NavigationGuard } from 'vue-router'
import { useTokenStore } from '@/stores/token'
import { redirectToRegenerateToken } from '@/shared/utils/regenerate-token'
import { ELocalStorageKey } from '@/shared/enum/local-storage.enum'

const localStorageTokenGuard: NavigationGuard = async (_to, _from, next) => {
  const tokenStore = useTokenStore()

  if (!tokenStore.token) {
    const tokenLocalStorage = localStorage.getItem(ELocalStorageKey.TOKEN_VALUE)

    if (tokenLocalStorage) {
      tokenStore.setToken(tokenLocalStorage)
    } else {
      await redirectToRegenerateToken()
      return
    }
  }

  next()
}

export default localStorageTokenGuard
